import { DigitalTrust } from "@carbon/pictograms-react";
import { Heading, Section, Stack } from "@carbon/react";
import { Tooltip } from "@flaminem/ui-components";
import { FC } from "react";
import { Link } from "react-router-dom";

import { useT } from "src/internationalization";
import { BlacklistedCaseIdentifier } from "src/types/case";

type BlacklistIdentifiersEmptyViewProps = {
  tooltip: { blacklistedIdentifiers?: BlacklistedCaseIdentifier[] };
};

export const FormEmptyView: FC<BlacklistIdentifiersEmptyViewProps> = ({ tooltip }) => {
  const t = useT();

  return (
    <div className="h-full flex flex-col items-center justify-center">
      <DigitalTrust fill="green" height={128} width={128} />
      <Section level={3}>
        <Heading>{t("alerts.confirmFraud.identifiers.empty.title")}</Heading>
      </Section>
      <p>{t("alerts.confirmFraud.identifiers.empty.description")}</p>
      <EmptyViewTooltip blacklistedIdentifiers={tooltip.blacklistedIdentifiers} />
    </div>
  );
};

const EmptyViewTooltip: FC<BlacklistIdentifiersEmptyViewProps["tooltip"]> = ({
  blacklistedIdentifiers,
}) => {
  const t = useT();

  return (
    <Tooltip
      maxWidth="max-content"
      content={
        <div className="text-left text-textInverse text-sm">
          <Stack gap={3}>
            <div>
              <Section level={5}>
                <Heading>{t("alerts.confirmFraud.identifiers.empty.tooltip.title")} </Heading>
              </Section>
              <p className="text-sm text-textInverse">
                {t("alerts.confirmFraud.identifiers.empty.tooltip.description")}
              </p>
            </div>
            {blacklistedIdentifiers && blacklistedIdentifiers.length > 0 ? (
              <div>
                {blacklistedIdentifiers.map(({ identifier, blacklistElement }, index) => (
                  <div key={index} className="flex gap-5">
                    <div className="flex-1">
                      {identifier.identifierType.name}: {identifier.value}
                    </div>
                    <div className="flex-1">{blacklistElement.blacklist.code}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-helperText01">
                {t("alerts.confirmFraud.identifiers.empty.tooltip.helper")}
              </div>
            )}
          </Stack>
        </div>
      }
    >
      <Link to="" className="no-underline">
        <p className="text-bodyCompact01">
          {t("alerts.confirmFraud.identifiers.empty.tooltip.link")}
        </p>
      </Link>
    </Tooltip>
  );
};
